 <oly-modal-view
   [blackBody]="true"
   [showCloseButton]="isLicenseActivated"
   [dialogRef]="dialogRef"
   headerTitle="License"
   [showHeader]="true"
   titleIconName="key"
   titleIconSet="regular"
 >
   <div>
     <evi-input
       id="licenseKey"
       olyAutofocus
       label="License key"
       type="text"
       [fullWidth]="true"
       [isReadOnly]="licenseReadOnly"
       [disabled]="licenseReadOnly"
       [(ngModel)]="licenseKeyModel"
     ></evi-input>

     @if (showErrorMessage) {
       <div class="license-modal__error-container">
         <unis-icon
           class="license-modal__error-icon"
           font="solid"
           icon="triangle-exclamation"
         />
         <p class="license-modal__error-message">{{errorMessage}}</p>
       </div>
     }
   </div>

   @if (!showDeactivationWarning) {
     <div class="license-modal__license-information">
       @if (license) {
         <h4 class="license-modal__license-information-header">License: {{ license.name }}</h4>
         <ul class="license-modal__license-information-list">
           <li>Status: {{ license.status }}</li>
           <li>Expiration: {{ getExpirationDate(license.expiryDate) }}</li>
         </ul>
       }

       @if (enabledFeatures.length > 0) {
         <h4 class="license-modal__license-information-header">Features</h4>
         <ul class="license-modal__license-information-list">
           @for (feature of enabledFeatures; track feature) {
             <li>
               <span>{{ feature.name }}</span>
               <ul class="license-modal__license-information-sublist">
                 <li>
                   Expiration: {{ getExpirationDate(feature.expires) }}
                   @if (isExpired(feature.expires)) {
                     <span>(expired)</span>
                   }
                 </li>
               </ul>
             </li>
           }
         </ul>
       }
     </div>
   }

   @if (showDeactivationWarning) {
     <div class="license-modal__deactivate-container">
       <unis-icon
         class="license-modal__deactivate-icon"
         icon="exclamation-triangle"
         font="solid"
       />

       <div class="license-modal__deactivate-description-container">
         <p>
           You are about to unregister this device from the license key above. You won't be able to access {{appName}}
           licensed features from this device anymore.
         </p>
         <br>
         <p>
           <strong>
             Please confirm that you deliberately want to deactivate this license
           </strong>
         </p>
         <br>
         <p>
           Once deactivated, the application will close, and you will need to restart it to enter a new license key.
         </p>
       </div>
     </div>
   }

   <ng-container slot="modal-footer">
     <div [ngClass]="{'license-modal__actions-container' : !showDeactivationWarning}">
       @if (!showDeactivationWarning) {
         <evi-button
           id="deactivate"
           label="Deactivate"
           [secondary]="true"
           [largePadding]="true"
           [disabled]="!canDeactivate"
           (tgclick)="toggleDeactivateButtonDisplay()"
         ></evi-button>
       }

       <div>
         @if (showDeactivationWarning) {
           <evi-button
             id="deactivate"
             label="Deactivate"
             [dangerBackground]="true"
             [largePadding]="true"
             (tgclick)="deactivateLicense()"
           ></evi-button>
         }

         @if (!canDeactivate && !showDeactivationWarning) {
           <evi-button
             id="activate"
             label="Activate"
             [primary]="true"
             [largePadding]="true"
             (tgclick)="activateLicense()"
           ></evi-button>
         }

         @if (showDeactivationWarning) {
           <evi-button
             id="cancel"
             label="Cancel"
             [secondary]="true"
             [largePadding]="true"
             (tgclick)="toggleDeactivateButtonDisplay()"
           ></evi-button>
         }

         @if (!isLicenseActivated && !showDeactivationWarning) {
           <evi-button
             id="quit"
             label="Quit"
             [secondary]="true"
             [largePadding]="true"
             (tgclick)="closeApp()"
           ></evi-button>
         }

         @if (isLicenseActivated && !showDeactivationWarning) {
           <evi-button
             id="close"
             label="Close"
             [secondary]="true"
             [largePadding]="true"
             (tgclick)="closeDialog()"
           ></evi-button>
         }
       </div>
     </div>
   </ng-container>
 </oly-modal-view>
